import Api from "./api"

export const postPaymentToken = async (amount) => {
    const response = await Api.post(`/v1/payment/checkout/create-payment-intent?amount=${amount}`)
    return response;
};